import React from 'react';
import classnames from 'classnames';
import { Button, Content, Dialog, Flex, Text } from '@leverege/ui-elements';
import S from './DefaultDialog.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function DefaultDialog(props) {
  const {
    show,
    title,
    titleIcon,
    onSubmit,
    submit,
    submitVariant = 'primary',
    submitText = 'Submit',
    submitIcon,
    submitDisabled = false,
    submitHidden = false,
    onCancel,
    cancelVariant = 'secondary',
    cancelText = 'Cancel',
    cancelIcon,
    cancelDisabled = false,
    cancelHidden = false,
    onClose,
    children,
    headerClassName,
    contentClassName,
    contentAreaClassName
  } = props;
  const headerClasses = headerClassName ? classnames(headerClassName, S.header) : S.header;
  const contentClasses = contentClassName ? classnames(contentClassName, S.content) : S.content;
  const contentAreaClasses = contentAreaClassName ? classnames(contentAreaClassName, S.contentArea) : S.contentArea;
  return /*#__PURE__*/_jsx(Dialog, {
    className: S.dialog,
    show: show,
    closeOnEscape: true,
    closeOnDocumentClick: true,
    onClose: onClose,
    children: /*#__PURE__*/_jsxs(Content, {
      relative: true,
      className: contentClasses,
      children: [/*#__PURE__*/_jsx(Content.Header, {
        variant: "itemFormHeader|formHeader",
        className: headerClasses,
        children: /*#__PURE__*/_jsxs(Flex, {
          direction: "row",
          align: "center",
          justify: "space-between",
          children: [/*#__PURE__*/_jsx(Text, {
            variant: "dialogTitle",
            icon: titleIcon,
            imageOpts: {
              style: {
                height: '24px'
              }
            },
            children: title
          }), /*#__PURE__*/_jsx(Button, {
            variant: "closeDialog",
            onClick: onClose
          })]
        })
      }), /*#__PURE__*/_jsx(Content.Area, {
        variant: "itemFormBody|formBody",
        className: contentAreaClasses,
        children: children
      }), /*#__PURE__*/_jsxs(Content.Footer, {
        variant: "itemFormFooter|formButtons",
        layout: "flex:rowMEnd",
        children: [!cancelHidden && /*#__PURE__*/_jsx(Button, {
          variant: cancelVariant,
          type: "button",
          disabled: cancelDisabled,
          onClick: onCancel || onClose,
          icon: cancelIcon,
          children: cancelText
        }), submit || !submitHidden && /*#__PURE__*/_jsx(Button, {
          variant: submitVariant,
          disabled: submitDisabled,
          onClick: onSubmit,
          icon: submitIcon,
          children: submitText
        })]
      })]
    })
  });
}
export default DefaultDialog;